<script setup lang="ts">
import { useJitsiStore } from "@/stores/jitsiStore";
import { storeToRefs } from "pinia";
defineProps<{
  minimized?: boolean;
  minimize?: () => void;
  close?: () => void;
}>();
const store = useJitsiStore();
const { toggleVideo, toggleAudio } = store;
const { isMuted, isVideoMuted } = storeToRefs(store);
</script>

<template>
  <div
    class="absolute tw:!bottom-0 tw:left-1/2 tw:-translate-x-1/2 tw:w-[calc(100%-2rem)] tw:max-w-[300px] tw:h-[60px] tw:bg-[#181C20] tw:flex tw:items-center tw:justify-center tw:gap-3 tw:rounded-xl tw:mx-auto tw:my-2 tw:shadow-lg tw:relative tw:z-content-overlay"
  >
    <v-btn
      icon
      class="tw:!bg-primary tw:shadow-none"
      @click.stop="minimize"
    >
      <v-icon color="white">{{ minimized ? "mdi-fullscreen" : "mdi-fullscreen-exit" }}</v-icon>
    </v-btn>
    <v-btn
      icon
      class="tw:!bg-primary tw:shadow-none"
      @click.stop="toggleAudio"
    >
      <v-icon color="white">{{ isMuted ? "mdi-microphone-off" : "mdi-microphone" }}</v-icon>
    </v-btn>
    <v-btn
      icon
      class="tw:!bg-primary tw:shadow-none"
      @click.stop="toggleVideo"
    >
      <v-icon color="white">{{ isVideoMuted ? "mdi-video-off" : "mdi-video" }}</v-icon>
    </v-btn>
    <v-btn
      icon
      class="tw:!bg-red-600 tw:shadow-none"
      @click.stop="close"
    >
      <v-icon color="white">mdi-phone-hangup</v-icon>
    </v-btn>
  </div>
</template>
